<div class="blacklist-administration">

    <div class="top-toolbar">
        <button mat-stroked-button type="button" (click)="cancel()" [disabled]="loading || !dirty">
            {{'cancel' | translate:['tmc-yard.widgets.blacklist-administration.action.cancel',
            translationService.language]}}
        </button>

        <div class="spaced"></div>

        <button mat-flat-button type="button" (click)="save()" [disabled]="loading || !dirty || !valid">
            {{'save' | translate:['tmc-yard.widgets.blacklist-administration.action.save',
            translationService.language]}}
        </button>
    </div>

    <app-service-response [responseMessages]="responseMessages"></app-service-response>

    <div class="table-container">

        <table mat-table [dataSource]="dataSource" class="table">

            <ng-container matColumnDef="company">
                <th mat-header-cell *matHeaderCellDef>
                    {{'company'| translate:['tmc-common.entity.blacklist.company',
                    translationService.language]}}
                </th>
                <td mat-cell class="" *matCellDef="let blacklist">
                    <ng-container *ngIf="!this.selection.isSelected(blacklist)">
                        {{blacklist.company}}
                    </ng-container>
                    <ng-container *ngIf="this.selection.isSelected(blacklist)">
                        <mat-form-field class="">
                            <input matInput [(ngModel)]="blacklist.company"
                                (ngModelChange)="blacklistDetailsChanged(blacklist)">
                        </mat-form-field>
                    </ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>
                    {{'name'| translate:['tmc-common.entity.blacklist.name',
                    translationService.language]}}
                </th>
                <td mat-cell class="" *matCellDef="let blacklist">
                    <ng-container *ngIf="!this.selection.isSelected(blacklist)">
                        {{blacklist.name}}
                    </ng-container>
                    <ng-container *ngIf="this.selection.isSelected(blacklist)">
                        <mat-form-field class="">
                            <input matInput [(ngModel)]="blacklist.name"
                                (ngModelChange)="blacklistDetailsChanged(blacklist)">
                        </mat-form-field>
                    </ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="firstname">
                <th mat-header-cell *matHeaderCellDef>
                    {{'firstname'| translate:['tmc-common.entity.blacklist.firstname',
                    translationService.language]}}
                </th>
                <td mat-cell class="" *matCellDef="let blacklist">
                    <ng-container *ngIf="!this.selection.isSelected(blacklist)">
                        {{blacklist.firstname}}
                    </ng-container>
                    <ng-container *ngIf="this.selection.isSelected(blacklist)">
                        <mat-form-field class="">
                            <input matInput [(ngModel)]="blacklist.firstname"
                                (ngModelChange)="blacklistDetailsChanged(blacklist)">
                        </mat-form-field>
                    </ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="numberPlate">
                <th mat-header-cell *matHeaderCellDef>
                    {{'numberPlate'| translate:['tmc-common.entity.blacklist.number-plate',
                    translationService.language]}}
                </th>
                <td mat-cell class="" *matCellDef="let blacklist">
                    <ng-container *ngIf="!this.selection.isSelected(blacklist)">
                        {{blacklist.numberPlate}}
                    </ng-container>
                    <ng-container *ngIf="this.selection.isSelected(blacklist)">
                        <mat-form-field class="">
                            <input matInput [(ngModel)]="blacklist.numberPlate"
                                (ngModelChange)="blacklistDetailsChanged(blacklist)">
                        </mat-form-field>
                    </ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="note">
                <th mat-header-cell *matHeaderCellDef>
                    {{'note'| translate:['tmc-common.entity.blacklist.note',
                    translationService.language]}}
                </th>
                <td mat-cell class="" *matCellDef="let blacklist">
                    <ng-container *ngIf="!this.selection.isSelected(blacklist)">
                        {{blacklist.note}}
                    </ng-container>
                    <ng-container *ngIf="this.selection.isSelected(blacklist)">
                        <mat-form-field class="">
                            <input matInput [(ngModel)]="blacklist.note"
                                (ngModelChange)="blacklistDetailsChanged(blacklist)">
                        </mat-form-field>
                    </ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="btn">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell class="" *matCellDef="let blacklist">
                    <div *ngIf="this.selection.isSelected(blacklist)" (click)="delete(blacklist)">
                        <sc-icon iconClass="fa-trash"></sc-icon>
                    </div>
                    <div class="invalid-marker" *ngIf="!this.selection.isSelected(blacklist) && !blacklist.valid">

                    </div>
                </td>
            </ng-container>

            <!-- Displays a "no data" row when no rows are available. Prevents the table from looking nasty-->
            <ng-container matColumnDef="noRecord">
                <td class="no-record" [colSpan]="this.columnsToDisplay.length" mat-footer-cell *matFooterCellDef>
                    {{'no data available' | translate: ['shared.tmc-table.nodata', translationService.language]}}
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

            <tr mat-row *matRowDef="let blacklist; columns: columnsToDisplay" [attr.data-blacklist-id]="blacklist.id"
                [ngClass]="blacklist.selected ? 'row-selected': 'row-deselected'" (click)="toggleSelection(blacklist)">
            </tr>

            <tr [class.hide]="this.dataSource.filteredData.length !== 0" mat-footer-row *matFooterRowDef="['noRecord']">
            </tr>
        </table>
    </div>

    <div class="bottom-toolbar">
        <button mat-flat-button type="button" (click)="addDetails()" [disabled]="loading">
            <sc-icon iconClass="fa-plus"></sc-icon>
        </button>
    </div>
</div>